export default {
  setCategories(state, categories) {
    state.categories = categories;
  },
  setGroupsfilter(state, groupsFilter) {
    state.groupsFilter = groupsFilter;
  },
  setGroup(state, group) {
    state.group = group;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
